import { API } from "../../api";
async function client_token(query) {
    // console.log("client_token -> query", query);
    const clientId = process.env.LETS_TRADE_CLIENT_ID;
    return await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_CLIENT_URL ?? "",
        endpoint: `v2/client?_id=${clientId}`,
        noAuth: true,
    });
}
export { client_token };
